const constants = require('./config/settings.' + process.env.REACT_APP_ENVIRONMENT);

const jgApiUrl = constants.jgApiUrl;

const searchServiceUrl = constants.searchServiceUrl;

export const URL = {
  get user() { return getJgApiUrl('/api/v1/user') },
  get event() { return getJgApiUrl('/api/v1/events') },
  get season() { return getJgApiUrl('/api/v1/seasons') },
  get seasonsettings() { return getJgApiUrl('/api/v1/seasonsettings') },
  get center() { return getSearchServiceUrl('/api/v1/centers') },
  get member() { return getJgApiUrl('/api/v1/member') },
  get postevent() { return getJgApiUrl('/api/v1/postevent') },
  get reports() { return getJgApiUrl('/api/v1/reports') },
  get member_dev() { return getSearchServiceUrl('/api/v1/Membership/Member') },
}

export const UserManagerConfig = getOidcConfig();
export const SSOProfileURL = GetEditProfileURL();

function getJgApiUrl(route) {
  return `${jgApiUrl}${route}`;
}

function getSearchServiceUrl(route) {
  return `${searchServiceUrl}${route}`;
}


function GetEditProfileURL() {
  return constants.ssoUrl + '/Manage?clientId=JRGOLD_CLIENT_D25F9215-A088-443A-907F-EDA57E8A5B96';
}

function getOidcConfig() {
  return {
    authority: constants.ssoUrl,
    client_id: "JRGOLD_CLIENT_D25F9215-A088-443A-907F-EDA57E8A5B96",
    redirect_uri: constants.siteUrl + "/signin-oidc",
    response_type: "id_token token",
    scope: "openid profile JRGOLD_APIKEY_3E8D1D07-243F-4DA9-B297-3FD12DA7DF2F Usbc.Web.Profile",
    post_logout_redirect_uri: constants.siteUrl + "/signout-callback-oidc",
    silent_redirect_uri: constants.siteUrl + "/signin-silentrenew",
    automaticSilentRenew: true
  };
}


// WEBPACK FOOTER //
// ./src/config.js